import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { setRegister } from "../../../features/RegisterSlice";
import { PatternFormat } from "react-number-format";
import { SearchCust } from "services/Api/Module/Customer";

import PageHeader from "layouts/inc/PageHeader";
import PageTitle from "layouts/inc/PageTitle";

import Helper, {
  checkIdCardFormat,
  convertMobileNoFormat,
  breakKeyDownEnter,
} from "services/helper";

import useTranslations from "../../../i18n/useTranslations";

const RegisterUser = () => {
  const { t } = useTranslations(); // แปลภาษา

  const dispatch = useDispatch(); // ไว้อัพเดต state กลาง
  const stateRegister = useSelector((state) => state.register); // ไว้ดึง state
  const stateProfile = useSelector((state) => state.profile);

  /* Set state Register {currentPage} on goNext & goBack */
  const navigate = useNavigate();
  const [page, setPage] = useState("register");

  const PageRoute = {
    home: "/",
    "auth-otp": "/auth-otp",
  };

  const setCurrentPage = (currentPage) => {
    const tmpObj = { currentPage: currentPage };
    dispatch(setRegister(tmpObj)); // setStateRedux ส่งค่าเก็บเข้า state กลาง
  };

  const setPrevPage = (prevPage) => {
    const tmpObj = { prevPage: prevPage };
    dispatch(setRegister(tmpObj)); // setStateRedux ส่งค่าเก็บเข้า state กลาง
  };

  const goBack = (newPage) => {
    setPrevPage(page);
    setCurrentPage(newPage);
    navigate(PageRoute[newPage]);
  };

  const goNext = (newPage) => {
    setPrevPage(page);
    setCurrentPage(newPage);
    navigate(PageRoute[newPage]);
  };
  /* End Set state Register {currentPage} on goNext & goBack */

  /* Form */
  const {
    control,
    watch,
    setValue,
    getValues,
    handleSubmit,
    formState: { errors },
    setError,
    clearErrors,
    getFieldState,
  } = useForm({
    defaultValues: {
      fullname: "",
      idCard: "",
      birthDate: "",
      mobileNo: "",
      isConsent: false,
    },
  });

  // console.log("isValid: ", isValid);
  const [formIsValid, setFormIsValid] = useState(false);

  const handleCheckOnChange = () => {
    const _field = getValues();
    let _invalidState = true,
      _invalidFields = [];

    for (const key in _field) {
      const val = _field[key];
      // console.log(key, typeof val, val);

      let _invalid = getFieldState(key).invalid;
      if (val === "" || val === false || val === null) {
        _invalid = true;
      }

      if (key === "idCard") {
        if (val.length === 13) {
          handleCheckIdCardExists(val);
        } else {
          _invalid = true;
        }
      }

      _invalidFields.push(_invalid);
    }

    _invalidState = _invalidFields.includes(true);

    if (_invalidState === true) {
      setFormIsValid(false);
    } else {
      setFormIsValid(true);
    }

    // console.log("onChange", _invalidState);
  };

  useEffect(() => {
    if (typeof formIsValid === "boolean") {
      // console.log(formIsValid);
    }
  }, [formIsValid]);
  /* End Form */

  /* Handle click submit form */
  const onSubmit = (data) => {
    setDataRegis({ ...data, mobileNo: convertMobileNoFormat(data.mobileNo) });

    // console.log('onSubmit >>', data);
    goNext("auth-otp");
  };

  const setDataRegis = (newData = {}) => {
    const tmpObj = { dataUser: newData };
    dispatch(setRegister(tmpObj)); // setStateRedux ส่งค่าเก็บเข้า state กลาง
  };
  /* End Handle click submit form */

  /* onClick privacy policy save form data temp  */
  const setTempDataRegis = () => {
    const updateData = {
      fullname: watch("fullname"),
      idCard: watch("idCard"),
      birthDate: watch("birthDate"),
      mobileNo: convertMobileNoFormat(watch("mobileNo")),
      isConsent: watch("isConsent"),
    };
    // console.log("setTempDataRegis >>", updateData);
    setDataRegis(updateData);
  };
  /* End onClick privacy policy save form data temp */

  /* Check ID card exists real-time on server-side  */
  const handleCheckIdCardExists = (idCard) => {
    // console.log(idCard);

    if (checkIdCardFormat(idCard)) {
      clearErrors("idCard");

      getSearchCust({
        q: "register",
        idCard: idCard,
      }).then((_rsData) => {
        // console.log(_rsData);

        if (_rsData.status === true) {
          setFormIsValid(false);

          setError(
            "idCard",
            {
              type: "manual",
              message: `${t.formField.idCard.validate.existing}`,
            },
            {
              shouldFocus: true,
            }
          );
        } else {
          clearErrors("idCard");
        }
      });
    } else {
      setFormIsValid(false);

      setError(
        "idCard",
        {
          type: "manual",
          message: `${t.formField.idCard.validate.pattern}`,
        },
        {
          shouldFocus: true,
        }
      );
    }
  };

  const getSearchCust = async (payload) => {
    let _return = {
      status: false,
      result: null,
    };

    try {
      const { data } = await SearchCust({ params: payload });
      if (data.resultCode === 20200) {
        const resData = data.body;
        // console.log("getSearchCust resData >>", resData);

        _return.status = true;
        _return.result = resData;
      }
    } catch (e) {
      console.log("ERR getSearchCust >> ", e);
    }

    return _return;
  };
  /* End Check ID card exists real-time on server-side  */

  /* First event render */
  useEffect(() => {
    if (stateProfile.lineUid !== null && stateProfile.custNo !== null) {
      navigate("/profile");
    }

    const { dataUser } = stateRegister;

    // console.log("useEffect !", stateRegister);

    if (Object.keys(dataUser).length !== 0) {
      setValue("fullname", dataUser.fullname);
      setValue("idCard", dataUser.idCard);
      setValue("birthDate", dataUser.birthDate);
      setValue("mobileNo", convertMobileNoFormat(dataUser.mobileNo, "-"));
      setValue("isConsent", dataUser.isConsent);

      let _chkFormIsValid = true;
      Object.entries(dataUser).forEach(([key, val]) => {
        if (val === "" || val === false || val === null) {
          _chkFormIsValid = false;
        }
      });

      if (_chkFormIsValid === true) {
        setFormIsValid(true);
      }
    }
  }, []);
  /* End First event render */

  return (
    <>
      <Helmet>
        <title>ห้างเพชรทองโกลด์เด้น 99 จำกัด</title>
        <meta name="title" content="ห้างเพชรทองโกลด์เด้น 99 จำกัด" />
        <meta
          name="description"
          content="ห้างเพชรทองโกลด์เด้น 99 จำกัด จำหน่ายสินค้าทุกหมวดหมู่ของเครื่องประดับ ทั้งในรูปแบบทองรูปพรรณ 96.5% ลวดลายสวยงาม ทองคำเปอร์เซ็นต์สูง  รับซื้อและจำนำตามราคาสมาคม..."
        />
        <meta name="keyword" content="" />
        <meta property="og:title" content="ห้างเพชรทองโกลด์เด้น 99 จำกัด" />
        <meta
          property="og:description"
          content="ห้างเพชรทองโกลด์เด้น 99 จำกัด จำหน่ายสินค้าทุกหมวดหมู่ของเครื่องประดับ ทั้งในรูปแบบทองรูปพรรณ 96.5% ลวดลายสวยงาม ทองคำเปอร์เซ็นต์สูง  รับซื้อและจำนำตามราคาสมาคม..."
        />
        <meta property="og:image" content="" />
        <meta property="og:url" content="assets/img/share/share-cover.jpg" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="GOLDEN99" />
      </Helmet>

      <div id="pageRegisterNew">
        <PageHeader />
        <main>
          <div className="wrapContent">
            <PageTitle />

            <section id="pTitleContentMain">
              <div className="bTitleContent">
                <div className="tTag">{t.registerPage.headTitle}</div>
                <div className="bLogo">
                  <img src="assets/img/logo/logo-color.svg" alt="Logo-G99" />
                </div>
                <h2>{t.registerPage.headSubTitle}</h2>
                <div className="tStep">
                  <span>2/3</span>
                </div>
              </div>
            </section>
            <form
              onSubmit={handleSubmit(onSubmit)}
              onKeyDown={(e) => breakKeyDownEnter(e)}
            >
              <section id="pRegisterMain">
                <div className="bRegister">
                  <h3>
                    <img src="assets/img/ci/ico-register-round.svg" alt="" />
                    {t.registerPage.formTitle}
                  </h3>
                  <div className="bForm">
                    <div className="bRow">
                      <div
                        className={`control-group ${
                          errors.fullname ? "error" : ""
                        }`}
                      >
                        <div className="tTitle">
                          {t.formField.fullname.label}
                        </div>
                        <Controller
                          name="fullname"
                          control={control}
                          defaultValue=""
                          rules={{
                            required: `${t.formField.fullname.validate.required}`,
                          }}
                          render={({ field: { onChange, ...field } }) => (
                            <input
                              {...field}
                              type="text"
                              placeholder={t.formField.fullname.placeHolder}
                              onInput={Helper.FNFORM.handleCharOnly}
                              onChange={({ target: { value } }) => {
                                onChange(value);
                                handleCheckOnChange();
                              }}
                            />
                          )}
                        />
                        {errors.fullname && (
                          <label htmlFor="" className="tError">
                            {errors.fullname.message}
                          </label>
                        )}
                      </div>
                    </div>
                    <div className="bRow">
                      <div
                        className={`control-group ${
                          errors.idCard ? "error" : ""
                        }`}
                      >
                        <div className="tTitle">{t.formField.idCard.label}</div>
                        <Controller
                          name="idCard"
                          control={control}
                          defaultValue=""
                          rules={{
                            required: `${t.formField.idCard.validate.required}`,
                            pattern: {
                              value: /^\d{13}$/,
                              message: `${t.formField.idCard.validate.pattern}`,
                            },
                          }}
                          render={({ field: { onChange, ...field } }) => (
                            <input
                              {...field}
                              type="text"
                              maxLength={13}
                              minLength={13}
                              placeholder={t.formField.idCard.placeHolder}
                              onInput={Helper.FNFORM.handleNumberOnly}
                              onChange={({ target: { value } }) => {
                                onChange(value);
                                handleCheckOnChange();
                              }}
                            />
                          )}
                        />
                        {errors.idCard && (
                          <label htmlFor="" className="tError">
                            {errors.idCard.message}
                          </label>
                        )}
                      </div>
                    </div>
                    <div className="bRow">
                      <div
                        className={`control-group ${
                          errors.birthDate ? "error" : ""
                        }`}
                      >
                        <div className="tTitle">
                          {t.formField.birthDate.label}
                        </div>
                        <Controller
                          name="birthDate"
                          control={control}
                          defaultValue=""
                          rules={{
                            required: `${t.formField.birthDate.validate.required}`,
                          }}
                          render={({ field: { onChange, ...field } }) => (
                            <input
                              {...field}
                              type="date"
                              onChange={({ target: { value } }) => {
                                onChange(value);
                                handleCheckOnChange();
                              }}
                            />
                          )}
                        />
                        {errors.birthDate && (
                          <label htmlFor="" className="tError">
                            {errors.birthDate.message}
                          </label>
                        )}
                      </div>
                    </div>
                    <div className="bRow">
                      <div
                        className={`control-group ${
                          errors.mobileNo ? "error" : ""
                        }`}
                      >
                        <div className="tTitle">
                          {t.formField.mobileNo.label}
                        </div>
                        <Controller
                          name="mobileNo"
                          control={control}
                          defaultValue=""
                          rules={{
                            required: `${t.formField.mobileNo.validate.required}`,
                            pattern: {
                              value: /^\d{3}-\d{3}-\d{4}$/, // /^\d{10}$/,
                              message: `${t.formField.mobileNo.validate.pattern}`,
                            },
                          }}
                          render={({ field: { name, value, onChange } }) => (
                            <PatternFormat
                              name={name}
                              value={value}
                              displayType="input"
                              format="###-###-####"
                              placeholder={t.formField.mobileNo.placeHolder}
                              onChange={({ target: { value } }) => {
                                onChange(value);
                                handleCheckOnChange();
                              }}
                            />
                          )}
                        />
                        {errors.mobileNo && (
                          <label htmlFor="" className="tError">
                            {errors.mobileNo.message}
                          </label>
                        )}
                      </div>
                    </div>
                    <div className="bRow">
                      <div
                        className={`control-group pdpa ${
                          errors.isConsent ? "error" : ""
                        }`}
                      >
                        <label className="control control--checkbox">
                          <p>
                            {t.formField.isConsent.label.str1 + " "}
                            <Link
                              to="/privacy-policy"
                              onClick={() => setTempDataRegis()}
                            >
                              {t.formField.isConsent.label.str2}
                            </Link>
                            {" " + t.formField.isConsent.label.str3}
                          </p>
                          <Controller
                            name="isConsent"
                            control={control}
                            defaultValue=""
                            rules={{
                              required: `${t.formField.isConsent.validate.required}`,
                            }}
                            render={({ field }) => (
                              <input
                                {...field}
                                type="checkbox"
                                checked={watch("isConsent")}
                                onChange={(e) => {
                                  field.onChange(e.target.checked);
                                  handleCheckOnChange();
                                }}
                              />
                            )}
                          />
                          <div className="control__indicator"></div>
                        </label>
                        {errors.isConsent && (
                          <label htmlFor="" className="tError">
                            {errors.isConsent.message}
                          </label>
                        )}
                      </div>
                    </div>
                    {/* <p className="tError">Text Error Main Form</p> */}
                  </div>
                </div>
              </section>
              <section id="pActionBtn">
                <div className="bBtn">
                  <button
                    className="btn outline"
                    onClick={(e) => {
                      e.preventDefault();
                      goBack("home");
                    }}
                  >
                    {t.btn.back}
                  </button>
                  <button
                    className="btn"
                    type="submit"
                    disabled={formIsValid ? false : true}
                  >
                    {t.btn.next}
                  </button>
                </div>
              </section>
            </form>
          </div>
        </main>
      </div>
    </>
  );
};

export default RegisterUser;
